import createSagaMiddleware from 'redux-saga';
import { createStore, combineReducers, applyMiddleware, compose } from 'redux';
import * as reducers from './ducks';
import rootSaga from './sagas';

export default (initialState, context = {}) => {
  const reducer = combineReducers(reducers);
  const preloadedState = Object.assign(
    {},
    window.__REACT_REDUX_PAYLOAD__,
    initialState
  );
  const sagaMiddleware = createSagaMiddleware();
  const composeEnhancers =
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

  let store = createStore(
    reducer,
    preloadedState,
    composeEnhancers(applyMiddleware(sagaMiddleware))
  );
  sagaMiddleware.run(rootSaga, context);

  return store;
};



// WEBPACK FOOTER //
// ./src/configureStore.js